const objectFilter = (obj: object, predicate: (key, value) => boolean) =>
  Object.fromEntries(Object.entries(obj).filter(predicate))

export default objectFilter
